import { render, staticRenderFns } from "./MypageMessageTitle.vue?vue&type=template&id=32ec4c62"
import script from "./MypageMessageTitle.vue?vue&type=script&lang=js"
export * from "./MypageMessageTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports